export default __webpack_public_path__ + "static/media/roadmap.3fd7b5f4.png";